/* eslint-disable no-unused-expressions */
import { css, createGlobalStyle } from '@nfront/global-styles';

const globalStyle = css`
  * {
    box-sizing: border-box;
  }

  html {
    overflow-x: hidden;
    background-color: #272e4a;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: #272e4a;
    background: linear-gradient(to bottom, #272e4a 0, #151b27 100%);
    color: ${props => props.theme.textBaseColor};
    font-family: ${props => props.theme.fontFamily};
    font-size: 16px;
    line-height: 1;
    overflow-x: hidden;
    min-height: 100vh;
  }

  body.rtl {
    direction: rtl;
  }

  .grecaptcha-badge {
    visibility: hidden !important;
  }

  #___gatsby {
    min-height: 100vh;
  }

  #___gatsby > div {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  main {
    flex: 1 1 100%;
  }

  button {
    font-family: ${props => props.theme.fontFamily};
    font-size: 16px;

    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;

    background: transparent;

    /* inherit font & color from ancestor */
    color: inherit;

    /* Normalize line-height. Cannot be changed from normal in Firefox 4+. */
    line-height: normal;

    /* Corrects font smoothing for webkit */
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;

    /* Corrects inability to style clickable input types in iOS */
    appearance: none;
  }

  button:hover {
    cursor: pointer;
  }

  button::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  button:focus {
    outline: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
`;

export const GlobalStylesComponent = createGlobalStyle`
    ${globalStyle}
  `;

export default GlobalStylesComponent;
